import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const STEPS = [
  { n: "01", t: "Submit", d: "Start an online submission, choose your service tier, and log each card's details. Add optional autograph services per card." },
  { n: "02", t: "Receive & Log", d: "Our team receives your package, logs every card into the MAS system, and confirms it against your submission." },
  { n: "03", t: "Grade & Encapsulate", d: "Certified experts assess centering, corners, edges, and surface under controlled light, then seal each card in a tamper-evident holder." },
  { n: "04", t: "Certify & Return", d: "A unique cert number and live population entry are issued, and your graded slab ships safely back to you." },
];

export default function Process() {
  return (
    <div className="bg-white" data-testid="process-page">
      <Seo title="How to Get Cards Graded — The Grading Process" description="How trading card grading works at MAS, step by step — submit your cards, we receive and log them, grade and encapsulate, then certify and return with a live population entry." path="/process" />
      <PageHeader eyebrow="How it works" title="Four steps to a certified slab" subtitle="From your collection to a tamper-evident, population-tracked MAS slab — fast, secure, and fully verifiable online." word="STEPS" />
      <section className="max-w-4xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="space-y-2">
          {STEPS.map((s) => (
            <div key={s.n} className="flex gap-6 md:gap-10 py-8 border-b border-neutral-100 last:border-0">
              <div className="font-display font-900 text-4xl md:text-6xl text-neutral-200 shrink-0 w-16 md:w-24" style={{ fontWeight: 900 }}>{s.n}</div>
              <div>
                <h3 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight text-[#0A0A0A]">{s.t}</h3>
                <p className="text-neutral-500 mt-3 leading-relaxed max-w-xl">{s.d}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-14">
          <Link to="/submit" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0A0A0A] text-white font-bold rounded-full hover:bg-neutral-800 transition-colors duration-300">Start a Submission <ArrowRight size={16} /></Link>
        </div>
      </section>
    </div>
  );
}
